<section class="app-pil-top">
  <img class="app-pil-top__img d-block d-sm-none" alt="banner" [src]="bannerMobUrl()" />
  <img class="app-pil-top__img d-none d-sm-block" alt="banner" [src]="bannerUrl()" />
</section>
